export default "__VITE_ASSET__B4PI5CGw__"